module.exports = __webpack_public_path__ + "static/img/1-4.8b81a48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/1-4.png
// module id = LGfr
// module chunks = 1